import React from 'react';
import classNames from 'classnames';

const ActCard = ({ id, name = '', searchCount = 0, onClick = () => {} }) => {
  const classes = classNames({
    'acts-item': true
  });

  return (
    <div className={classes} onClick={onClick}>
      <div className="acts-item-name">{name}</div>
      <div className="acts-item-search-count">{searchCount} kpl</div>
    </div>
  );
};

export default ActCard;
